import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import RouterContext from "../../context/RouterContext";
import { styled } from '@mui/material/styles';
import LinearProgress from '@mui/material/LinearProgress';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import InfoIcon from '@mui/icons-material/Info';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import "../../App.css";
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import {ThreeDots} from 'react-loader-spinner';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import {updateSeduta} from "./Utils";
import {properties} from "../../utils/properties";
import { BannerBozza, filigranaBozza } from "./AnteprimaBozza"; // ANTEPRIMA

export default function Card() {
    
    let {idDossier, idScheda } = useParams();    
    const [loading, setLoading]= React.useState(true);  
    const [score, setScore] = useState([]);
    const [homeData, setHomeData] = useState([]);    
    const navigate = useNavigate();
    const { pageRouter, setPageRouter } = useContext(RouterContext);     
    const meetingId = idDossier;   
    
    const [color, setColor] = useState([]);
    const [faseProvenienza, setFaseProvenienza] = useState();

    var dateStyle = {
        display: "flex",
        paddingLeft: "25px",
    };
    const id=idScheda;

    const onClickToUpdate= (e ) => {   
        if (!loading) { setLoading(true);} 
        
        if( properties.verboseLog==1)
            console.log("octu",e);         
        e.stopPropagation(); 

        axios.get(properties.productionUrl+'/postIDSF?IDS='+idScheda).then(response => {                        
            if( properties.verboseLog==1)
                console.log("THEN",response);            
        }).catch(({response}) => {                        
            console.log("CATCH",response);
            
        }).finally(() => {
            if( properties.verboseLog==1)
                console.log("FINALLY",);            
            window.location.reload(false);               
        });
        
    };

    const updateUI = function(jsonData) {
        const keyValuScores = jsonData;
        //console.log("UUII",keyValuScores.fase);
        setFaseProvenienza(keyValuScores.fase);
        const homeFieldsItem = Object.entries(keyValuScores.components.home.fields);
        if( properties.verboseLog==1)
            console.log("HFI",homeFieldsItem);
        var homeItems = [];
        let obiettivo;
        for (var i = 0; i < homeFieldsItem.length; i++) {
            var firstItemCss = "0px";
            var itemBorderColor = "";

            if (i === 0) {
                firstItemCss = "8px";
            }
            if (
                homeFieldsItem[i][1]["componentRef"] ||
                (homeFieldsItem[i][1]["style"] === 0 &&
                    !homeFieldsItem[i][1]["secondValue"] &&
                    !homeFieldsItem[i][1]["comment"])
            ) {
                itemBorderColor = "1px solid #EFEFEF";
            }
            if( properties.verboseLog==1){
                console.log("home", homeFieldsItem[i]);
                console.log("home1",keyValuScores);
            }

            if (homeFieldsItem[i][1]["label"]==="Obiettivo") {
                obiettivo = homeFieldsItem[i][1]["value"];
            }
            var item = {
                componentRef: homeFieldsItem[i][1]["componentRef"],
                label: homeFieldsItem[i][1]["label"],
                value: homeFieldsItem[i][1]["value"],
                style: homeFieldsItem[i][1]["style"],
                second: homeFieldsItem[i][1]["secondValue"],
                comment: homeFieldsItem[i][1]["comment"],
                table: homeFieldsItem[i][1]["table"],
                itemcss: firstItemCss,
                bordercss: itemBorderColor,
            };
            if(item.table)
                item.table.shift();
            homeItems.push(item);
        }        
        setHomeData(homeItems);
             
        var keyExist = keyValuScores.hasOwnProperty("scoreboard");
        if (keyExist) {
            setScore(keyValuScores.scoreboard.score1Level);
        }  
        setLoading(false);
        //console.log("VEDIAMO",homeItems);
    }

    const doPostSeduta2 = function() {
    
        var xhr2 = new XMLHttpRequest();                        
        xhr2.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/checkScheda.php',true);
        xhr2.withCredentials = true;
        xhr2.setRequestHeader("Content-type", "application/x-www-form-urlencoded");    
        xhr2.onload = function (e) {      
            if (xhr2.readyState === 4) {
                if (xhr2.status === 200) {                              
                    if( properties.verboseLog==1)
                        console.log("OK92",xhr2);
                    var responseText = xhr2.responseText;                    
                    var obj=JSON.parse(responseText);
                    if( properties.verboseLog==1)
                        console.log("OK93",obj);          
                    if(obj.status==="204" ){ 
                        console.log("OK CARD 204",xhr2);
                        const SchedaInfo = JSON.parse(localStorage.getItem("schedaContent"));
                        updateUI(SchedaInfo);
                    }              
                    else{
                        //status 201
                        console.log("OK CARD 201",xhr2);

                        try{
                            localStorage.setItem("schedaContent", obj.content);
                            localStorage.setItem("scheda", idScheda);
                            localStorage.setItem("schedaVersion", obj.date);                                                                                                        
                        }
                        catch(error) {
                            console.log("LOCALSTORAGE ISSUE", error);
                        }                 
                        const SchedaInfo = JSON.parse(obj.content);
                        updateUI(SchedaInfo);
                    }
                } 
                else {
                    //console.error("Error 1", xhr.statusText);          
                    window.alert("Errore recuperando la scheda 1");                      
                    navigate("/editor",{ replace: true });                      
                }
            }
        };

        xhr2.onerror = function (e) {
            console.error("Error 22", xhr2.statusText);
        };
    
        let urlEncodedData = "ids=" + idScheda;
        if (localStorage.scheda===idScheda){            
            if( properties.verboseLog==1)
                console.log( "QUINDIC=00");
            const currentData=localStorage.getItem("schedaVersion");
            console.log("TEST CD", currentData);    
            if(currentData!= undefined && currentData!= "undefined")
                urlEncodedData = urlEncodedData+ "&date=" + currentData;                    
            console.log("TEST CD", urlEncodedData);        
        }    
        xhr2.send(urlEncodedData);
    }


    useEffect(() => {              
        updateSeduta(meetingId,doPostSeduta2,updateUI);        
    }, []);
    
    const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
        height: 10,
        borderRadius: 5,
        backgroundColor: theme.palette.grey[theme.palette.mode === "light" ? 300 : 700], 
        '& .MuiLinearProgress-bar': {
          borderRadius: 5,
          backgroundColor: '#5cb85c',
        },
      }));

    const openScoreBoard = (id) => {
        navigate("/schede/"+ idScheda + "/scoreboard");  
    };

    const goFinalInfo = (refname) => {
        if( properties.verboseLog==1)
            console.log("called goFinalInfo");
        if (refname) {            
            navigate("/schede/"+ idScheda + "/" + refname);  
        }
    };

    // ANTEPRIMA: il contenuto è lo stesso di SpecificCard (card reale nel fascicolo),
    // con in più la fascia BOZZA e la filigrana. Restano di Card: caricamento della scheda e navigazione.
    return (        
        <div> 
        {loading ? (
            <div key={uuidv4()} style={{ width:"25%",   display: "flex", 
            marginLeft: "auto", marginRight: "auto" }}> 
             <ThreeDots color="#30720f" height='350' width='150'/>
             </div> 
        ):(
        <div className="content" style={{ position: "relative" }}>
            <BannerBozza />
        <div style={{
            marginLeft: "0px",
            width: "100%",
            height: "10px",
            //background: "#00FF00",
            //background: color,
            //borderBottomRightRadius: "8px",
            //borderTopRightRadius: "8px",
            }}> </div>
            <div>
                {homeData.length > 0 &&
                //homeData.map((item, index) => (                        
                homeData.filter(item => !(item.label === "Missione" && item.value === "CONVENZIONI, PROGETTI SPECIALI, ULTERIORI PRATICHE E DOCUMENTI"))
                    .map((item, index) => (
                        <div
                            className="common-list specific-card-list-row"
                            key={index}
                            style={{                                
                                margin: "0px",
                                borderRadius: "0px",
                                borderTopLeftRadius: item.itemcss,
                                borderTopRightRadius: item.itemcss,
                                borderBottom: item.bordercss,    
                                //paddingLeft: "30px",                            
                            }}
                            //onClick={() => goFinalInfo(item.componentRef)}
                        >
                        

                            {item.componentRef && !item.comment ? (
                                item.label === "Executive Summary" ? (
                                    //console.log("e21",item.value),
                                    //console.log("e22",item),
                                    <div
                                        className="specific-card-row"
                                        style={{                                            
                                            display:"block",  
                                            width: "100%",     
                                            padding: "0px 25px",
                                            margin: "20px 0px",
                                            textAlign: "left",
                                            cursor: "pointer",     
                                            //backgroundColor:"blue"
                                        }}
                                        onClick={() =>
                                            goFinalInfo(item.componentRef)
                                        }
                                    >
                                        <p className="text importantText">
                                           {item.label}:
                                        </p>
                                       
                                        <div>
                                            <p className="text"
                                            style={{                                                
                                                whiteSpace: 'pre-wrap' }}
                                            dangerouslySetInnerHTML={{
                                                __html: item.value,
                                            }}
                                            />  
                                        </div>
                                     {item.table ? (
                            item.table.map((extraitem, index) => (
                            //console.log("uff",item),
                                <div
                                    key={index}
                                    style={{ paddingBottom: "20px" }}                                  
                                    >  
                                 <p className="text"                                            
                                            dangerouslySetInnerHTML={{
                                                __html: extraitem[3],
                                            }}
                                            />  

                                </div>


                            ))
                        ) : (
                            <></>
                        )}


                                    </div>


                                ) : (
                                

                                    <div
                                        className="specific-card-row"
                                        style={{                                            
                                            display:"block",  
                                            width: "100%",                                          
                                            padding: "0px 25px",
                                            margin: "20px 0px",
                                            textAlign: "left",
                                            cursor: "pointer",
                                          
                                        }}
                                        onClick={() =>
                                            goFinalInfo(item.componentRef)
                                        }
                                    >
                                        <p className="text importantText textInLine ">
                                            {item.label}:
                                        </p>
                                        <p className="text normalTextInLine"
                                            dangerouslySetInnerHTML={{
                                                __html: item.value,
                                            }}
                                        />        
                                    </div>
                                )
                            ) : !item.componentRef &&
                              !item.comment &&
                              (item.style === 0 || item.style === 2) ? (
                              //console.log("e32",item.value),
                                item.label === "Executive Summary" ? (

                                    <div
                                        className="specific-card-row"
                                        style={{
                                            textAlign: "left",
                                            paddingLeft: "25px",
                                            paddingRight: "25px",
                                        }}
                                    >
                                        <p className="text importantText">
                                            {item.label}:
                                        </p>                                        
                                        <div
                                            style={{ paddingBottom: "20px", whiteSpace: 'pre-wrap' }}     >                         
                                        <p className="text" 
                                            style={{                                                          
                                                whiteSpace: 'pre-wrap' 
                                            }}
                                             dangerouslySetInnerHTML={{
                                                __html: item.value,
                                            }}
                                        />
                                    </div>




                                        {item.table &&
                                            item.table.map(
                                                (extraitem, index) => (
                                                //console.log ("ei",extraitem),
                                                    <div
                                                        key={index}
                                                        style={{
                                                            paddingBottom:"20px",
                                                        }}
                                                        
                                                    >

                                                     <p className="text normalTextInLine" 
                                            style={{                                                          
                                                whiteSpace: 'pre-wrap' 
                                            }}
                                             dangerouslySetInnerHTML={{
                                                __html: extraitem[3],
                                            }}
                                        />
                                    </div>   

                                                )
                                            )}
                                    </div>
                                ) : item.label === "Descrizione" ? (  
                                    //console.log("e122",item.value),                              
                                    <div
                                        className="specific-card-row"
                                        style={{
                                            textAlign: "left",
                                            padding: "0px 15px",
                                        }}
                                    >
                                        <p className="text importantText">
                                            {item.label}:
                                        </p>
                                        {/* HTML: il valore arriva dall'editor (es. <p>...</p>): va interpretato, non mostrato come testo */}
                                        <p className="text"
                                            style={{                                                
                                                textAlign: "justify",
                                            }}
                                            dangerouslySetInnerHTML={{ __html: item.value }}
                                        />
                                    </div>
                                ) 
                                : item.label === "Missione" && item.value === "CONVENZIONI, PROGETTI SPECIALI, ULTERIORI PRATICHE E DOCUMENTI"? (  
                                    console.log("questo non lo vedrò mai perchè filtro prima del mapping...",item.value),                              
                                    <>
                                    </>                                  
                                ) 
                                : (
                                    //console.log("boh", item),
                                    <div className="specific-card-row" style={{ paddingLeft: "25px", 
                                    display:"block", textAlign: "left",
                                      padding: "0px 25px",
                                    margin: "20px 0px",

                                }}>
                                        <p className="text importantText textInLine" >
                                            {item.label}:
                                        </p>
                                        <p className="text normalTextInLine" 
                                            style={{                                                
                                                paddingRight: "25px",
                                                whiteSpace: 'pre-wrap' 
                                            }}
                                             dangerouslySetInnerHTML={{
                                                __html: item.value,
                                            }}
                                        />
                                    </div>
                                )
                            ) : item.style && item.second ? (
                                //console.log("e39",item.value),
                                <div
                                    style={{
                                        //background: "#FEADB0",                                                
                                        background: "#a2ee7d",
                                        color: "#4B0307",
                                        textAlign: "left",
                                        padding: "0px 25px",
                                        width: "100%"
                                    }}
                                    className="company-info specific-card-row"
                                >
                                    <Accordion
                                        style={{
                                            //background: "rgb(254, 173, 176)",
                                            //background: "#FF0000",
                                            background: "#a2ee7d",
                                            boxShadow: "unset",                                            
                                        }}
                                       
                                    >
                                        <AccordionSummary
                                            expandIcon={
                                                <InfoIcon
                                                    style={{
                                                        //color: "rgb(75, 3, 7)",
                                                        color: "#30720f",
                                                        top: "-32px !important",
                                                        background:
                                                            "unset !important",
                                                    }}
                                                />
                                            }
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                            style={{                                                                                             
                                                userSelect: "text",
                                                padding: "0px",
                                                flexDirection: "unset",
                                            }}
                                        >
                                            <Typography component={'div'}>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                            "space-between",
                                                    }}
                                                >
                                                    <p className="text" >
                                                        {item.label}:
                                                    </p>
                                                </div>
                                                <p className="text"
                                                style={{ marginTop: "0px", whiteSpace: 'pre-wrap' }}
                                                    dangerouslySetInnerHTML={{ __html: item.value }} />
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails
                                            style={{ padding: "0px" }}
                                        >
                                            <Typography component={'div'}>                                                
                                                <p className="text">
                                                    Ruolo della compagnia:
                                                </p>
                                                <p className="text" style={{ marginTop: "0px", whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{ __html: item.second }} />
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                </div>
                            ) : item.comment ? (
                                //console.log("e72",item.value),
                                //console.log("e73",item.comment),
                                <div
                                    className="specific-card-row"
                                    style={{
                                        textAlign: "left",
                                        padding: "0px 25px",
                                    }}
                                >
                                    <div>
                                        <p className="text importantText">
                                            {item.label}:
                                        </p>
                                        <p className="text"
                                            style={{                                                
                                                whiteSpace: 'pre-wrap' }}
                                            dangerouslySetInnerHTML={{
                                                __html: item.value,
                                            }}
                                        />    
                                           
                                    </div>
                                    <div
                                        className="specific-card-row"
                                        style={{
                                            color: "#879497",
                                            padding: "0px 25px",
                                            //border: "1px solid #FEADB0",
                                            border: "1px solid #30720f",
                                            borderRadius: "20px",
                                            margin: "40px 0px",
                                        }}
                                    >
                                        <p className="text" style={{
                                            
                                            fontSize: "14px",
                                        }}>
                                            Commento:
                                        </p>
                                         <p className="text"

                                            style={{                                                
                                                whiteSpace: 'pre-wrap', fontSize: "14px" }}
                                            dangerouslySetInnerHTML={{
                                                __html: item.comment,
                                            }}
                                        />  
                                    </div>
                                </div>
                            ) : item.style &&
                              !item.comment &&
                              !item.secondValue &&
                              !item.componentRef ? (
                              //console.log("ho", item),
                              
                                <div
                                    className="specific-card-row"
                                    style={{                                        
                                        //background: "#FEADB0",
                                        background: "#a2ee7d",
                                        color: "#4B0307",
                                        textAlign: "left",
                                        padding: "0px 25px",
                                        border: "1px solid rgb(239, 239, 239)",
                                        width: "100%",
                                    }}
                                >
                                
                                    <div
                                        style={{
                                           display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                   
                                        <p className="text">
                                            {item.label}: 
                                        </p>
                                    </div>
                                  
                                     <p className="text"
                                            style={{                                            
                                            whiteSpace: 'pre-wrap' }}
                                            dangerouslySetInnerHTML={{
                                                __html: item.value,
                                            }}

                                         
                                        />  
                                     
                                </div>
                            ) : (
                                <></>
                            )}
                            {item.componentRef ? (
                                //console.log ("cref", item),
                                <div
                                    className="specific-card-arrow"
                                    style={{
                                        color: "#879497",
                                        display: "flex",
                                        cursor:"pointer"
                                    }}
                                    onClick={() =>
                                        goFinalInfo(item.componentRef)
                                    }
                                >
                                    <KeyboardArrowRightIcon sx={{ color: '#879497' }} fontSize="large"/>
                                </div>
                            ) : (
                                <></>
                            )}
                        </div>
                    ))}

                {score.length ? (
                    <div
                        className="scoreboard"
                        onClick={() => openScoreBoard(id)}
                        style={{
                                //paddingLeft: "50px",
                                cursor: "pointer",
                            }}
                    >
                        <div
                            style={{

                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",                                
                            }}
                        >
                            <p className="text importantText">Scoreboard:</p>
                            <div
                                style={{
                                    color: "#879497",
                                    display: "flex",                                    
                                }}
                            >
                               <KeyboardArrowRightIcon sx={{ color: '#879497' }} fontSize="large"/>                                
                            </div>
                        </div>
                        {score.map((item, index) => (
                            <div key={index}>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alingItems: "center",
                                    }}
                                >
                                    <p className="text">{item.label}</p>
                                    <p className="text">{item.number}/10</p>
                                </div>
                                <BorderLinearProgress
                                    variant="determinate"
                                    value={item.number * 10}
                                />
                            </div>
                        ))}
                    </div>
                ) : (
                    <></>
                )}
            </div>
            <div aria-hidden="true" style={filigranaBozza} />
        </div>
    )}</div>      
    );
}
